document.addEventListener('DOMContentLoaded', function () {
  const productGrid = document.querySelector('#product-grid');
  const paginationWrapper = document.querySelector('#infinite-scroll-pagination');

  if (!productGrid || !paginationWrapper) return;

  let isLoading = false;

  function getNextUrl() {
    return paginationWrapper.dataset.nextUrl || '';
  }

  async function loadMoreProducts() {
    const nextUrl = getNextUrl();
    if (!nextUrl || isLoading) return;

    isLoading = true;

    try {
      const response = await fetch(nextUrl);
      if (!response.ok) throw new Error('Erro ao carregar mais produtos');

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('#product-grid');
      const newItems = newGrid ? newGrid.querySelectorAll('li.grid__item') : [];

      newItems.forEach((item) => {
        productGrid.appendChild(item);
      });

      // atualizar o wrapper de paginação com o novo next-url
      const newPaginationWrapper = doc.querySelector('#infinite-scroll-pagination');
      if (newPaginationWrapper) {
        const newNextUrl = newPaginationWrapper.dataset.nextUrl || '';
        if (newNextUrl) {
          paginationWrapper.dataset.nextUrl = newNextUrl;
        } else {
          paginationWrapper.dataset.nextUrl = '';
          paginationWrapper.remove();
          window.removeEventListener('scroll', handleScroll);
        }
      } else {
        paginationWrapper.dataset.nextUrl = '';
        paginationWrapper.remove();
        window.removeEventListener('scroll', handleScroll);
      }
    } catch (e) {
      console.error(e);
      window.removeEventListener('scroll', handleScroll);
    } finally {
      isLoading = false;
    }
  }

  function handleScroll() {
    const scrollPosition = window.innerHeight + window.scrollY;
    const triggerPosition = document.body.offsetHeight - 400;

    if (scrollPosition >= triggerPosition) {
      loadMoreProducts();
    }
  }

  window.addEventListener('scroll', handleScroll);
});
